export const isSSR = (): any => (globalThis as any).__SERVER__ ?? false;

export const getAggSubscriptionEndpoint = () =>
	`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
